import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { profileRoute } from '.'

const FinancialTransaction = lazyRouteComponent(
  () => import('../../pages/profile/financial-transaction'),
)

type FinancialTransactionSearch = {
  tab: string
}

export const financialTransactionRoute = createRoute({
  getParentRoute: () => profileRoute,
  path: 'financial-transaction',
  component: FinancialTransaction,
  validateSearch: (search: { tab?: string }): FinancialTransactionSearch => {
    return {
      tab:
        search.tab === 'all' ||
        search.tab === 'deposit' ||
        search.tab === 'withdrawals'
          ? search.tab
          : 'all',
    }
  },
})
